import FilterComponent from '@components/Default/Search/FilterComponent';
import RangePickerComponent from '@components/Default/Search/RangePicker';
import SearchComponent from '@components/Default/Search/SearchComponent';
import HistoryComponentEhss from '@components/HistoryComponentEhss';
import PageWithoutTitle from '@components/PageWithoutTitle';
import UserRadioSelect from '@components/userRadioSelectComponent';
import Ticket from '@interfaces/ehss/ticket';
import ConfigService from '@services/global/Config';
import TicketEvent from '@services/graphQL/graphQLticketEvt';
import HistoryRequestsInterceptor from '@services/HistoryRequestService';
import ProcessManagementService from '@services/ProcessManagement';
import TicketEventRequestsInterceptor from '@services/TicketEventRequestService';
import TicketGlobalService from '@services/TicketService';
import NotificationComponent from '@src/helpers/_showNotifications';
import ProcessRequestsInterceptor from '@src/helpers/interceptors/ProcessRequestInterceptor';
import { Button, Col, DatePicker, Form, Icon, Input, Modal, Row, Steps } from 'antd';
import pt_BR from 'antd/lib/locale-provider/pt_BR';
import findIndex from 'lodash/findIndex';
import React from 'react';
import styled from 'styled-components';

import Table from '../components/TableComponent';
import I18n from '../i18n';
import AppContext from '../services/Context';
import { LocalStorageKeys } from './App';
const moment = require('moment')

const Step = Steps.Step;
interface IPropType {
  form: any
}
interface IHistoryEhssStateType {
  tableData: any;
  loadingHistory: boolean;
  curOffset?: string;
  visibleModal: boolean;
  currentTicket: any;
  loadingTicket: boolean;
  loadingSeeMore: boolean;
  extraFields?: any;

  endTimeAndDate?: number;
  startTimeAndDate?: number;
  statusWanted?: number;
  orderBy?: number;
  orderByLabel?: string;
  getWithouFilters: boolean;
  selectedFieldId?: string;
  inputExtraFieldValue?: string;
  isCollapsed: boolean;
  disable: boolean;
  disableLoading: boolean;

  currentStep: number;
  showProcessModal: boolean;
  haveItemSelected: boolean;
  processSelectId: string;
  ProcessesData: any;
  curProcessesOffset?: string
  loadingProcessesBySearch: boolean;
  searchProcess: string;
  loadingDoneProcess: boolean
  loadingMoreProcesses: boolean;
  processFrom?: number;
  processTo?: number;

  search?: string;

};



const tableColumnsProcess = [
  {
    title: 'table.formflow.name',
    dataIndex: 'name',
    key: 'name',
    class: 'name',
    width: '30%'
  }, {
    title: 'table.formflow.version',
    dataIndex: 'version',
    key: 'version',
  },
];

const _formflowService: ProcessRequestsInterceptor = new ProcessRequestsInterceptor();
const _ticketService: TicketEventRequestsInterceptor = new TicketEventRequestsInterceptor();
export class HistoryEHSS extends React.Component<IPropType, IHistoryEhssStateType> {

  private _historyService: HistoryRequestsInterceptor = new HistoryRequestsInterceptor();
  private _ticketGlobalService: TicketGlobalService = new TicketGlobalService();
  private _ticketEvent: ProcessManagementService = new ProcessManagementService();
  private _configService: ConfigService = new ConfigService();
  private idUnit: string = "";
  private currentPillar: string = "";

  constructor(props: any) {
    super(props);
    this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))
    this.currentPillar = String(localStorage.getItem(LocalStorageKeys.PILLAR))

    this.state = {
      tableData: [],
      loadingHistory: false,
      loadingSeeMore: false,
      visibleModal: false,
      currentTicket: undefined,
      loadingTicket: false,
      orderByLabel: "modified",
      getWithouFilters: false,
      inputExtraFieldValue: '',
      isCollapsed: true,
      disable: false,
      disableLoading: false,

      currentStep: 0,
      showProcessModal: false,
      haveItemSelected: false,
      processSelectId: '',
      ProcessesData: [],
      loadingProcessesBySearch: false,
      searchProcess: '',
      loadingDoneProcess: false,
      loadingMoreProcesses: false

    }
  }
  componentDidMount() {
    this.initialData()
  }

  initialData = async () => {
    this.getHistory(true, true, true)
    this.getConfig();
    await this.getProcess(true)
  }

  tableColumn() {
    let ownerLabel: string = 'label.executor'
    if (this.currentPillar === 'EHSS') {
      ownerLabel = 'labels.auditor'
    }
    return ([
      {
        title: ownerLabel,
        dataIndex: 'owner.name',
        key: 'owner.name',
      },
      {
        title: 'table.startAt',
        dataIndex: 'startAt',
        key: 'startAt',
      }, {
        title: 'table.finishtAt',
        dataIndex: 'endAt',
        key: 'endAt',
      },
      {
        title: 'common.status',
        dataIndex: 'status',
        key: 'status',
      },
      {
        title: '',
        dataIndex: 'action',
        key: 'action',
        width: '30%',
      }]
    );
  }

  getConfig = async () => {
    try {
      const data: any = await this._configService.getGLOBAL();
      await this.setState({
        extraFields: data.userFields,
      });
    } catch (error) {
      console.warn(error);
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.update"), error);
    }
  };

  getHistory = async (reset: boolean, showLoading: boolean, withoutFilters: boolean, field?: string, value?: string) => {
    await this.setState({
      loadingHistory: showLoading,
      getWithouFilters: withoutFilters,
    });
    if (reset) {
      await this.setState({
        curOffset: undefined
      });
    }
    // TicketStatus.CLOSED
    try {
      let data;
      if (withoutFilters) {
        data = await this._historyService.paging(
          {
            unit: this.idUnit,
            status: undefined,
            orderBy: undefined,
            to: undefined,
            from: undefined,
            limit: 10,
            fieldId: field || undefined,
            fieldValue: value || undefined,
            offset: this.state.curOffset,
          });
      }
      
      else {
        data = await this._historyService.paging(
          {
            unit: this.idUnit,
            status: this.state.disable ? undefined : this.state.statusWanted,
            to: this.state.endTimeAndDate,
            from: this.state.startTimeAndDate,
            limit: 10,
            disable: this.state.disable,
            fieldId: this.state.selectedFieldId,
            fieldValue: this.state.inputExtraFieldValue,
            offset: this.state.curOffset,
            search: this.state.search
          });
      }
      let newTicketData: Ticket[] = [];

      if (!reset) {
        newTicketData = this.state.tableData || [];
      }

      newTicketData = newTicketData.concat(data.items);

      await this.setState({
        tableData: newTicketData,
        loadingHistory: false,
        loadingSeeMore: false,
        curOffset: data.offset
      });
    } catch (error) {
      console.warn("error getting history: ", error);
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.searchHistory"), error);
      await this.setState({
        loadingHistory: false,
      });
    }
  };

  async loadMoreHistory() {
    await this.setState({ loadingSeeMore: true });
    await this.getHistory(false, true, this.state.getWithouFilters);
  }

  toggleVisualize = async (currentTicket: any) => {
    await this.setState({
      visibleModal: !this.state.visibleModal,
      loadingTicket: true
    })
    const ticket = await this._ticketEvent.getGLOBAL(currentTicket.id, true)
    await this.setState({
      currentTicket: ticket,
      loadingTicket: false
    })
  }

  //#region Filters

  toggleCollapsableInstructions = () => {
    this.setState({
      isCollapsed: !this.state.isCollapsed
    });
  }

  onTimeRangeOk = async (e: any) => {
    const nextStartTimeAndDate = (e[0] !== undefined) ? e[0].toDate().getTime() : undefined;
    const nextEndTimeAndDate = (e[1] !== undefined) ? e[1].toDate().getTime() : undefined;

    await this.setState({ endTimeAndDate: nextEndTimeAndDate, startTimeAndDate: nextStartTimeAndDate });
  }

  filterData = async (status: any) => {
    if (status !== this.state.statusWanted) {

      if (status === 10) {
        await this.setState({
          disable: true,
          statusWanted: status
        })
      }
      else {
        await this.setState({
          disable: false,
          statusWanted: status
        })
      }
    }
  }


  filterDataClicked() {
    this.getHistory(true, true, false, this.state.selectedFieldId, this.state.inputExtraFieldValue);
  }

  seeAllClicked() {
    this.getHistory(true, true, true);
  }

  onTimeRangeChanged = async (evt: any) => {
    if (evt.length === 0) {
      await this.setState({
        startTimeAndDate: undefined,
        endTimeAndDate: undefined
      })
    }
  }
  //#endregion

  filedTicket = async (active: boolean, id: string, currentTicket: any) => {
    await this.setState({ disableLoading: true })
    try {
      const { tableData } = this.state;
      let newTableData: any = []
      const targetIndex = findIndex(
        tableData,
        (item: any) => item.id === id,
      );
      if (active) {
        tableData[targetIndex] = Object.assign(tableData[targetIndex], { disabled: undefined });
        await this._ticketGlobalService.filetTicket(id, currentTicket, false);
        await NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("history.notify.unfiledSuccess"));
      } else {
        tableData[targetIndex] = Object.assign(tableData[targetIndex], { disabled: true });
        await this._ticketGlobalService.filetTicket(id, currentTicket, true);
        await NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("history.notify.filedSuccess"));
      }
      newTableData = tableData.filter((e: any) => e.id !== id)
      await this.setState({
        // isLoading: false,
        tableData: newTableData,
        disableLoading: false
      });
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), e);
      console.error(e);
    }
  };

  onClickBack = async () => {
    await this.setState({ visibleModal: false })
  }



  //#region STEPS

  getTimezone = () => {
    const offset = new Date().getTimezoneOffset(), o = Math.abs(offset);
    return (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
  }

  getProcess = async (reset: boolean, user?: string) => {
    if (reset) {
      await this.setState({
        curProcessesOffset: undefined
      });
    }
    try {
      if (user != undefined) {
        if (this.idUnit) {

          const data: any = await _formflowService.paging({
            unit: this.idUnit,
            to: undefined,
            from: undefined,
            search: user,
            limit: 10,
            offset: this.state.curProcessesOffset,
            timezone: this.getTimezone()
          });
          let nextUsersData: any[] = [];

          if (!reset) {
            nextUsersData = this.state.ProcessesData || [];
          }
          nextUsersData = nextUsersData.concat(data.items);
          await this.setState({
            ProcessesData: nextUsersData,
            curProcessesOffset: data.offset,
            loadingProcessesBySearch: false,
          });
        }
        else {
          throw new Error("No unit set");
        }
      }
      else {
        await this.setState({
          ProcessesData: [],
          curProcessesOffset: undefined,
          loadingProcessesBySearch: false,
        });
      }
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l('common.error'), error);
    }
  }


  handleUsersSearch = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;

    await this.setState({
      loadingProcessesBySearch: true,
      searchProcess: SearchValue,
    })
    try {
      this.getProcess(true, SearchValue);
    }
    catch (err) {
      console.log(err)
    }
  };
  onRadioItemSelectionChange = async (userId: string) => {
    await this.setState({
      haveItemSelected: !!userId,
      processSelectId: userId,
    });
  }

  loadMoreUsers = () => {
    this.setState({ loadingMoreProcesses: true, });
    this.getProcess(false, this.state.searchProcess);
  }

  renderProcessStep = (): JSX.Element => {
    const { ProcessesData: usersData, loadingProcessesBySearch: loadingUsersBySearch, searchProcess: searchUser, loadingMoreProcesses: loadingMoreUsers } = this.state
    return (
      <div className='goepik-component-padding'>
        <SearchResponsible>
          <SearchComponent
            onSubmit={this.handleUsersSearch}
            placeholder='form.placeholders.formflowSearch'
            buttonText='form.buttons.search'
          />
        </SearchResponsible>

        {usersData.length > 0 && (
          <UserRadioSelect
            columns={tableColumnsProcess}
            data={usersData}
            itemSelectionChanged={(userId: string) => this.onRadioItemSelectionChange(userId)}
            loadingMoreData={loadingMoreUsers}
            hasMoreData={this.state.curProcessesOffset != undefined && this.state.curProcessesOffset != ''}
            onShowMore={this.loadMoreUsers}
            valueSelected={''}
            notScroll={true}
          >
          </UserRadioSelect>
        )}
        {usersData.length == 0 && loadingUsersBySearch === false && searchUser.length == 0 && (
          <p className="goepik-component-padding">{I18n.l('common.loadingData')}</p>
        )}
        {loadingUsersBySearch === true && (
          <p className="goepik-component-padding">{I18n.l('common.loadingTable')}</p>
        )}
        {(usersData && usersData.length === 0 && searchUser.length > 0 && loadingUsersBySearch == false) && (
          <p className="goepik-component-padding">{I18n.l('common.noResult')}</p>
        )}
        {searchUser.length == 0 && (
          <p className="goepik-component-padding"></p>
        )}
      </div>
    )
  }

  onChangeFrom = async (evt: any) => {
    await this.setState({ processFrom: evt.toDate().getTime() })
  }
  onChangeTo = async (evt: any) => {
    await this.setState({ processTo: evt.toDate().getTime() })
  }

  renderStatusStep = (): JSX.Element => {
    return (
      <AppContext.Consumer>
        {({ locale }) => (
          <div className='goepik-component-padding'>
            <span>{I18n.l('form.taskflowschedule.labels.datebetweenradio.0')}</span>
            <div>
              <DatePicker
                onChange={this.onChangeFrom}
                format={I18n.l('common.dateFormat')}
                locale={(locale === "pt-BR") ? pt_BR.DatePicker : undefined}
              />
            </div>
            <span>{I18n.l('form.taskflowschedule.labels.datebetweenradio.1')}</span>
            <div>
              <DatePicker
                onChange={this.onChangeTo}
                format={I18n.l('common.dateFormat')}
                locale={(locale === "pt-BR") ? pt_BR.DatePicker : undefined}
              />
            </div>
          </div>
        )}
      </AppContext.Consumer>
    )
  }

  toggleFilterModal = async () => {
    await this.getProcess(true, '')
    await this.setState({
      showProcessModal: !this.state.showProcessModal,
      haveItemSelected: false,
      processSelectId: '',
      loadingDoneProcess: false,
      currentStep: 0
    });
  }

  onClickExportProcess = async () => {
    try {
      const data = await _ticketService.exportProcess(
        this.state.processSelectId,
        {
          unit: this.idUnit,
          to: this.state.processTo,
          from: this.state.processFrom,
        });


      const element = document.createElement('a');
      element.setAttribute('href', data.data);
      element.setAttribute('download', 'process.xlsx');
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);

      await this.toggleFilterModal()

    } catch (error) {
      console.log(error)
    }

  }

  renderAuditModal = (): JSX.Element => {

    const steps = [{
      title: I18n.l("auditconf.processSelectPlaceholder"),
      content: this.renderProcessStep(),
    }, {
      title: I18n.l("form.taskflowschedule.labels.dateradio"),
      content: this.renderStatusStep(),
    }];

    return (
      <Modal width={800} onCancel={this.toggleFilterModal} visible={this.state.showProcessModal} footer={false}>
        <ModalTitle>{I18n.l('common.filterBy')}</ModalTitle>
        <ModalContent>
          <Steps current={this.state.currentStep}>
            {steps.map(item => <Step key={item.title} title={item.title} />)}
          </Steps>
          <div className="steps-content" style={{ position: "relative" }}>
            {steps[this.state.currentStep].content}
          </div>
          <div className="steps-action" style={{ textAlign: 'right' }} >
            {this.state.currentStep > 0 && (
              <Button style={{ marginRight: 8 }} onClick={() => this.prevStep()}>
                {I18n.l('common.previous')}
              </Button>
            )}
            {this.state.currentStep < steps.length - 1 && (
              <Button disabled={this.state.processSelectId === '' ? true : false} type="primary" onClick={() => this.nextStep()}>
                {I18n.l('common.next')}
              </Button>
            )}
            {this.state.currentStep === steps.length - 1 && (
              <Button loading={this.state.loadingDoneProcess ? true : false} type="primary" onClick={this.onClickExportProcess}>
                {I18n.l('common.finish')}
              </Button>
            )}

          </div>
        </ModalContent>
      </Modal>
    );
  }
  nextStep() {
    const currentStep = this.state.currentStep + 1;
    this.setState({ currentStep });
  }

  prevStep() {
    const currentStep = this.state.currentStep - 1;
    this.setState({ currentStep });
  }

  onSearchChange = async (event: any) => {
    await this.setState({
        search: event.target.value,
    })
}

  //#endregion

  render() {
    const {
      tableData,
      curOffset,
      loadingHistory,
      loadingSeeMore,
      currentTicket
    } = this.state;
    return (
      <PageWithoutTitle>
        <div style={this.state.visibleModal ? { display: 'none' } : {}}>
          <h1 style={{ fontSize: '48px', fontWeight: 'bold', paddingBottom: '1rem' }} >{I18n.l('history.title')}</h1>
          <AppContext.Consumer>
            {({ locale, activeUnitId }) => (
              <div style={{ marginBottom: '1rem', marginTop: '1rem' }}>
                <Row type="flex" justify="start">
                  <Col sm={24} md={24} xl={24}>
                    <Col sm={24} md={12} xl={12}>
                      <Row>
                        <RangePickerComponent
                          title={I18n.l("history.filter.rangeTime.label")}
                          format={I18n.l('formats.date')}
                          locale={(locale === "pt") ? pt_BR.DatePicker : undefined}
                          onChange={this.onTimeRangeChanged}
                          placeHolder={['-/-/- --:--', '-/-/- --:--']}
                          onOk={this.onTimeRangeOk}
                        />
                      </Row>
                    </Col>
                  </Col>
                </Row>
                <div style={{ marginTop: '1rem' }} >
                  <Input
                    suffix={<Icon type="search" />}
                    style={{width: '350px'}}
                    placeholder={I18n.l('form.placeholders.distributorsSearch')}
                    // defaultValue={defaultValue || ""}
                    className='search-bar'
                  onChange={this.onSearchChange}
                  />
                </div>
                <Row className="goepik-component-padding">
                  <Col sm={24} md={12} xl={12} className="adjust-top-margin">
                    <FilterComponent
                      label={I18n.l("history.filter.filterMode.label")}
                      onClick={this.filterData}
                      buttons={{
                        text: {
                          active: 'form.filter.button.text.active',
                          deactive: 'form.filter.button.text.deactive',
                          all: 'form.filter.button.text.all',
                        }
                      }}
                      ticketGroupStatus={true}
                      curTicketStatus={this.state.statusWanted || undefined}
                    // disabled={disabled}
                    />
                  </Col>
                </Row>

                <Row type="flex" justify="start" className={"goepik-component-padding"} >
                  <Button size="large" type="primary" onClick={() => this.filterDataClicked()} className="goepik-btn-primary-main">{I18n.l('common.filter')}</Button>
                  <Button size="large" onClick={() => this.seeAllClicked()} className={"goepik-btn-border-main goepik-medium-left-margin"}>{I18n.l('common.seeAllResults')}</Button>
                  <Button size="large" type="primary" icon="download" className={"goepik-btn-primary-main goepik-medium-left-margin"} onClick={() => this.toggleFilterModal()}>{I18n.l('common.exportProcess')}</Button>
                </Row>
              </div>
            )}
          </AppContext.Consumer>
          {this.state.showProcessModal && (
            this.renderAuditModal()
          )}

          {/* Table */}
          {(tableData.length > 0) && (
            <>
              <div className={'goepik-component-tablesize'}>
                <Table
                  columns={this.tableColumn()}
                  data={tableData}
                  noPagination={true}
                  onVisualize={this.toggleVisualize}
                  showConfirmationModal={false}
                  onFiled={this.filedTicket}
                  disabledLoading={this.state.disableLoading}
                  deletePermission="can_delete_historic"
                  pillar={this.currentPillar}
                />
              </div>
              {curOffset && (
                <Button
                  className="loading-more"
                  type="primary"
                  size='large'
                  ghost
                  loading={loadingSeeMore ? true : false}
                  onClick={() => this.loadMoreHistory()}>{I18n.l('common.seeMore')}</Button>
              )}
            </>
          )}
          {(tableData.length === 0 && !loadingHistory) && <p>{I18n.l('common.noResult')}</p>}
          {this.state.loadingHistory &&
            <p>{I18n.l('common.loadingData')}</p>
          }
        </div>
        <div style={!this.state.visibleModal ? { display: 'none' } : {}}>
          
          <Row>
            <span style={{ color: 'black', fontSize: '48px', fontWeight: 'bold', paddingBottom: '1rem' }} >{this.currentPillar === "EHSS" ? I18n.l('history.detailTitle') : I18n.l('history.detailProcess')}</span>
            <Button
              type='primary'
              style={{ float: 'right', marginTop: '16px' }}
              onClick={this.onClickBack}
            >
              {I18n.l('common.back')}
            </Button>
          </Row>
          {this.state.loadingTicket &&
            <h3 style={{ marginTop: '3rem' }}>{I18n.l('common.loadingData')}</h3>
          }
          {(currentTicket && !this.state.loadingTicket) && (
            <>
              <div style={{ paddingLeft: '50px' }} >
                <HistoryComponentEhss
                  registers={currentTicket.items}
                  extralfield={this.state.extraFields}
                />
              </div>
            </>
          )}
        </div>
      </PageWithoutTitle>
    );
  }
}

export const HistoryEHSSContainerComponent = Form.create()(HistoryEHSS);


const SearchResponsible = styled.div`
    .search-component {
        max-width: 100% !important
    }
`;
const ModalTitle = styled.h3`
   font-size: 22px;
 `;

const ModalContent = styled.div`
 width: 100%;
                    
 .form-item-title{
   font-weight: bold;
   color:#333;
 }
 .form-item-error{
   color: #f00;
   margin-bottom:0px;
 }
                    
 .bottomAlign {
   position: absolute;
   bottom: 13px;
 }`;
